__turbopack_context__.v({
  "navigation--not-authenticated": "navigation-module-scss-module__kyW8mq__navigation--not-authenticated",
  "navigation-wrapper": "navigation-module-scss-module__kyW8mq__navigation-wrapper",
  "navigation__authentication": "navigation-module-scss-module__kyW8mq__navigation__authentication",
  "navigation__list": "navigation-module-scss-module__kyW8mq__navigation__list",
  "navigation__list-item-icon": "navigation-module-scss-module__kyW8mq__navigation__list-item-icon",
  "navigation__list-item-icon--expanded": "navigation-module-scss-module__kyW8mq__navigation__list-item-icon--expanded",
  "navigation__list-item-link": "navigation-module-scss-module__kyW8mq__navigation__list-item-link",
  "navigation__list-item-link--active": "navigation-module-scss-module__kyW8mq__navigation__list-item-link--active",
  "navigation__list-item-link--expanded": "navigation-module-scss-module__kyW8mq__navigation__list-item-link--expanded",
  "navigation__list-item-link__icon": "navigation-module-scss-module__kyW8mq__navigation__list-item-link__icon",
  "navigation__list-secondary": "navigation-module-scss-module__kyW8mq__navigation__list-secondary",
});
